import React, { useState, useContext, createContext } from 'react';

export const PaymentContext = createContext({
  enalble: true,
  setDisabled: () => {},
});


// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/NFePaymentShipping/Payments/context.js